export const SET_MINIMIZE_WINDOW = "SET_MINIMIZE_WINDOW";
export const ALTER_DISABLED_STATUS_OF_INPUTBOX = "ALTER_DISABLED_STATUS_OF_INPUTBOX";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-display-links/src/actions/actionTypes.js